"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6154],{

/***/ 60742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m49.431 258 35.334-32.666c41.332 20 67.545 35.217 114 68.333 87.334-99.109 145.041-149.39 252.307-216.128l11.498 26.447c-88.457 77.195-153.244 163.178-246.533 330.475C158.499 366.696 120.097 323.5 49.431 258z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCheckMark);

/***/ }),

/***/ 48957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ StyledChunk; },
/* harmony export */   "e": function() { return /* binding */ StyledHeader; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61516);
/* harmony import */ var _style_global_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43780);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var StyledHeader = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "erupouz1"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";color:", function (props) {
  return props.color === 'light' ? props.theme.shades.white : props.theme.shades.blackGrey;
}, ";font-weight:700;text-align:center;padding:", function (props) {
  return props.theme.spacing.xxLarge;
}, " 0 ", function (props) {
  return props.paddingBottom;
}, ";margin:0px;display:flex;flex-wrap:wrap;justify-content:center;line-height:25px;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.tabletAndUp */ .w5.tabletAndUp, "{background-color:", function (props) {
  return props.theme.shades.whiteGrey;
}, ";padding-top:0px;font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";font-weight:700;text-align:center;}" + ( true ? "" : 0));
var StyledChunk = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "erupouz0"
} : 0)( true ? {
  name: "1eo7ydk",
  styles: "padding-right:2px;padding-left:2px"
} : 0);

/***/ }),

/***/ 87080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ SectionHeadline; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _section_headline_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48957);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);




var SectionHeadline = function SectionHeadline(props) {
  var firstChunk = props.firstChunk,
      secondChunk = props.secondChunk,
      _props$color = props.color,
      color = _props$color === void 0 ? 'dark' : _props$color,
      _props$paddingBottom = props.paddingBottom,
      paddingBottom = _props$paddingBottom === void 0 ? '25' : _props$paddingBottom,
      headerType = props.headerType;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_section_headline_style__WEBPACK_IMPORTED_MODULE_1__/* .StyledHeader */ .e, {
    as: headerType,
    color: color,
    paddingBottom: paddingBottom + 'px',
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_section_headline_style__WEBPACK_IMPORTED_MODULE_1__/* .StyledChunk */ .Y, {
      children: firstChunk
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_section_headline_style__WEBPACK_IMPORTED_MODULE_1__/* .StyledChunk */ .Y, {
      children: secondChunk
    })]
  });
};

/***/ }),

/***/ 18210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Sticky; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
;// CONCATENATED MODULE: ./src/components/hoc/sticky/sticky.style.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var _ref =  true ? {
  name: "1l675nn",
  styles: "position:static"
} : 0;

var _ref2 =  true ? {
  name: "duudsh",
  styles: "position:fixed"
} : 0;

var StyledSticky = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "elromy90"
} : 0)("top:0;left:0;right:0;z-index:100;", function (props) {
  return props.sticky ? _ref2 : _ref;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/hooks/use-sticky/use-sticky.ts



/**
 * Returns a ref, and a stateful value bound to the ref
 *
 * @param staticRef is the reference of the element's stickiness
 * _Based on that element, it will detect if the element has above or below the `staticRef`_
 */
function useSticky(observerRef) {
  var stickyRef = react.useRef(null);

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      sticky = _React$useState2[0],
      setSticky = _React$useState2[1];

  react.useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var ratio = entry.intersectionRatio;
        var boundingRect = entry.boundingClientRect;
        var intersectionRect = entry.intersectionRect;
        var isSticky = ratio < 1 && boundingRect.top < intersectionRect.top;
        var isNotVisibleStickyElement = boundingRect.height === 0 && intersectionRect.height === 0;

        if (ratio === 0 && isNotVisibleStickyElement) {
          setSticky(true);
        }

        if (ratio === 0 && !isSticky) {
          return;
        }

        setSticky(isSticky);
      });
    }, {
      threshold: 1.0
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }
  }, [observerRef]);
  return {
    stickyRef: stickyRef,
    sticky: sticky
  };
}
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/hoc/sticky/sticky.tsx








/**
 * The Sticky component, that is exposing child props and thus can be used from outside
 */
var Sticky = function Sticky(props) {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      loaded = _React$useState2[0],
      setLoaded = _React$useState2[1];

  var _useSticky = useSticky(props.observerRef),
      stickyRef = _useSticky.stickyRef,
      sticky = _useSticky.sticky;

  react.useEffect(function () {
    setLoaded(true);
  }, []);
  var height = typeof props.height === 'number' ? props.height : stickyRef.current ? stickyRef.current.offsetHeight : 0;
  /**
   * `height > 0` - meaning the actual height is declared (the component is initialized)
   *
   * @NOTE ain't gonna work if we have lazy loaded content on wrapped element
   */

  var stickyStyle = height > 0 ? {
    pointerEvents: 'none',
    height: height
  } : null;
  var childrenStyle = {
    pointerEvents: 'all'
  };
  return loaded ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      style: {
        height: sticky ? height : 0
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSticky, {
      ref: stickyRef,
      sticky: sticky,
      style: stickyStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: childrenStyle,
        children: props.children(sticky)
      })
    })]
  }) : props.children(sticky);
};

/***/ }),

/***/ 50911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ StyledMargin; },
/* harmony export */   "F5": function() { return /* binding */ StyledOfferHeading; },
/* harmony export */   "G": function() { return /* binding */ StyledFlex; },
/* harmony export */   "H6": function() { return /* binding */ StyledContentWrapper; },
/* harmony export */   "Lh": function() { return /* binding */ StyledCompanyLogoWrapper; },
/* harmony export */   "MA": function() { return /* binding */ StyledButtonWrapper; },
/* harmony export */   "Q2": function() { return /* binding */ StyledMiddleSection; },
/* harmony export */   "T8": function() { return /* binding */ StyledIconListItem; },
/* harmony export */   "Tb": function() { return /* binding */ StyledMarketingOfferLabel; },
/* harmony export */   "UN": function() { return /* binding */ StyledTextLabelListItem; },
/* harmony export */   "Uv": function() { return /* binding */ StyledCheckMarkIcon; },
/* harmony export */   "Wj": function() { return /* binding */ StyledMarketingLabels; },
/* harmony export */   "YC": function() { return /* binding */ StyledOfferBoardCard; },
/* harmony export */   "Yo": function() { return /* binding */ StyledImage; },
/* harmony export */   "ad": function() { return /* binding */ StyledItineraryInfo; },
/* harmony export */   "dR": function() { return /* binding */ StyledUserLove; },
/* harmony export */   "eZ": function() { return /* binding */ StyledAspectRatio; },
/* harmony export */   "ez": function() { return /* binding */ StyledFlexSpaceBetween; },
/* harmony export */   "fW": function() { return /* binding */ StyledEventsInfo; },
/* harmony export */   "hE": function() { return /* binding */ StyledTextLabelList; },
/* harmony export */   "nn": function() { return /* binding */ StyledBottomSection; },
/* harmony export */   "uD": function() { return /* binding */ StyledDurationInfo; },
/* harmony export */   "wT": function() { return /* binding */ StyledIconList; },
/* harmony export */   "zT": function() { return /* binding */ StyledImageWrapper; },
/* harmony export */   "zV": function() { return /* binding */ StyledTopSection; }
/* harmony export */ });
/* unused harmony export StyledInfoCardLink */
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61516);
/* harmony import */ var _style_global_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43780);
/* harmony import */ var _public_static_icons_checkMark_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60742);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var StyledOfferBoardCard = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("article",  true ? {
  target: "enm87tq25"
} : 0)("color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";width:100%;padding-left:8px;padding-right:8px;display:flex;margin-bottom:20px;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.tablet */ .w5.tablet, "{width:calc(1 / 2 * 100%);}@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.smallDesktopAndUp */ .w5.smallDesktopAndUp, "{width:calc(1 / 3 * 100%);}@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.IE10or11 */ .w5.IE10or11, "{width:33%;}" + ( true ? "" : 0));
var StyledTopSection = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq24"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
var StyledImageWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq23"
} : 0)( true ? {
  name: "1cwloic",
  styles: "width:100%;overflow:hidden"
} : 0);
var StyledCompanyLogoWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq22"
} : 0)( true ? {
  name: "atqdhm",
  styles: "width:98px;height:60px;background-color:white;position:absolute;bottom:9px;text-align:center"
} : 0);
var StyledImage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("img",  true ? {
  target: "enm87tq21"
} : 0)( true ? {
  name: "11gor7f",
  styles: "width:auto;height:auto;max-width:100%;max-height:100%"
} : 0);
var StyledAspectRatio = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq20"
} : 0)("position:relative;&::before{position:relative;display:block;content:'';padding-bottom:calc(225 / 350 * 100%);@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.smallDesktopAndUp */ .w5.smallDesktopAndUp, "{padding-bottom:calc(225 / 370 * 100%);}}" + ( true ? "" : 0));
var StyledContentWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq19"
} : 0)( true ? {
  name: "1e27zof",
  styles: "position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden;img{object-fit:cover;object-position:center center;height:100%;width:100%;user-select:none;}"
} : 0);
var StyledInfoCardLink = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "enm87tq18"
} : 0)("color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";text-decoration:none;flex-grow:1;display:flex;flex-direction:column;cursor:pointer;&:focus,&:active,&:visited,&:hover{color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";text-decoration:none;}" + ( true ? "" : 0))));
var StyledButtonWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq17"
} : 0)( true ? {
  name: "1cybdf7",
  styles: "text-align:center;&& div button span:first-child{padding-left:12px!important;}"
} : 0);
var StyledMiddleSection = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq16"
} : 0)("width:100%;padding:", function (props) {
  return "".concat(props.theme.spacing.medium, " ").concat(props.theme.spacing.medium, " 0");
}, ";flex-grow:1;display:flex;flex-direction:column;" + ( true ? "" : 0));
var StyledFlex = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq15"
} : 0)("display:flex;justify-content:left;margin-top:", function (props) {
  return props.theme.spacing.small;
}, ";" + ( true ? "" : 0));
var StyledFlexSpaceBetween = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq14"
} : 0)("display:flex;justify-content:space-between;margin-bottom:", function (props) {
  return props.theme.spacing.medium;
}, ";&:nth-of-type(2){flex-grow:1;}" + ( true ? "" : 0));
var StyledMargin = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq13"
} : 0)("margin-bottom:", function (props) {
  return props.theme.spacing.medium;
}, ";" + ( true ? "" : 0));
var StyledDurationInfo = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq12"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";font-weight:600;line-height:1.42;" + ( true ? "" : 0));
var StyledEventsInfo = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq11"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";color:", function (props) {
  return props.theme.shades.midGrey;
}, ";padding-left:", function (props) {
  return props.theme.spacing.medium;
}, ";" + ( true ? "" : 0));
var StyledOfferHeading = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "enm87tq10"
} : 0)("display:flex;flex-grow:1;font-size:", function (props) {
  return props.theme.fontSize.headlineXS;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";line-height:1.22;font-weight:700;justify-content:center;text-align:center;margin:0;&:focus,&:active,&:visited,&:hover{color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";text-decoration:none;}" + ( true ? "" : 0));
var StyledItineraryInfo = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq9"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextXS;
}, ";color:", function (props) {
  return props.theme.shades.midGrey;
}, ";font-weight:600;" + ( true ? "" : 0));
var StyledBottomSection = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq8"
} : 0)("display:flex;flex-direction:column;justify-content:space-between;flex-grow:1;margin:", function (props) {
  return props.theme.spacing.medium;
}, " 0 ", function (props) {
  return props.theme.spacing.large;
}, ";overflow:hidden;" + ( true ? "" : 0));
var StyledTextLabelList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ul",  true ? {
  target: "enm87tq7"
} : 0)("padding-left:", function (props) {
  return props.theme.spacing.medium;
}, ";list-style:none;display:flex;margin-top:", function (props) {
  return props.theme.spacing.small;
}, ";flex-wrap:none;overflow:hidden;max-width:100%;flex-wrap:wrap;max-height:25px;flex-direction:row;" + ( true ? "" : 0));
var StyledTextLabelListItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li",  true ? {
  target: "enm87tq6"
} : 0)( true ? {
  name: "1xeecn4",
  styles: "margin-right:3px;word-break:none;word-wrap:none;white-space:nowrap;& :last-child{margin-right:0;}"
} : 0);
var StyledMarketingLabels = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq5"
} : 0)( true ? {
  name: "17ziqa",
  styles: "margin-top:2px;display:flex;flex-shrink:0;flex-direction:row;margin-right:auto"
} : 0);
var StyledMarketingOfferLabel = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "enm87tq4"
} : 0)("background-color:", function (props) {
  return props.color;
}, ";height:20px;font-size:10px;font-weight:600;color:", function (props) {
  return props.theme.shades.white;
}, ";margin-bottom:", function (props) {
  return props.theme.spacing.small;
}, ";margin-right:", function (props) {
  return props.theme.spacing.small;
}, ";display:flex;align-items:center;justify-content:center;padding:0 5px;" + ( true ? "" : 0));
var StyledUserLove = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "enm87tq3"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextS;
}, ";padding-left:", function (props) {
  return props.theme.spacing.medium;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";display:block;" + ( true ? "" : 0));
var StyledCheckMarkIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_public_static_icons_checkMark_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,  true ? {
  target: "enm87tq2"
} : 0)("fill:", function (props) {
  return props.theme.labels.onlineBookable;
}, ";height:20px;width:20px;margin-right:5px;" + ( true ? "" : 0));
var StyledIconList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ul",  true ? {
  target: "enm87tq1"
} : 0)( true ? {
  name: "ygg8pa",
  styles: "list-style:none;display:flex;flex-direction:row;width:100%;flex-wrap:wrap;padding:0"
} : 0);
var StyledIconListItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li",  true ? {
  target: "enm87tq0"
} : 0)("display:flex;align-items:center;justify-content:left;width:50%;padding:3px 10px;font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";font-weight:600;line-height:1.42;" + ( true ? "" : 0));

/***/ }),

/***/ 3354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useHandleSearchSubmit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_contexts_locale_config_locale_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36097);
/* harmony import */ var src_utils_EventTracker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6946);



var useHandleSearchSubmit = function useHandleSearchSubmit(_ref) {
  var id = _ref.id,
      type = _ref.type,
      title = _ref.title;
  var localeConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_contexts_locale_config_locale_config__WEBPACK_IMPORTED_MODULE_1__/* .LocaleConfigContext */ .nO);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (!type) return;
    window.location.href = "https://www.".concat(localeConfig.url, "/").concat(localeConfig.slugs.search, "?filterParams[").concat(type, "][0]=").concat(id);
    src_utils_EventTracker__WEBPACK_IMPORTED_MODULE_2__/* .eventTracker.track */ .xT.track({
      event: 'click',
      category: 'sticky-bar',
      action: 'search-button',
      label: "".concat(type, "-").concat(title)
    });
  }, [id, type, localeConfig.slugs.search, localeConfig.url]);
};

/***/ })

}]);